export default function(text: string, lng: string) {
  return replaces(lng).reduce((acc, replace) => {
    return acc.replace(replace.search, replace.replacement);
  }, text);
}

function replaces(lng: string) {
  return [
    {
      search: '{{privacyHref}}',
      replacement: `${window.location.origin}/auth/${lng}/privacy`
    },
    {
      search: '{{agreementHref}}',
      replacement: `${window.location.origin}/auth/${lng}/agreement`
    }
  ];
}
